import { Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BodyTextL, HeadingXL } from "../Typography";

export const Wrapper = styled(Stack)(({ theme }) => ({
    display: "flex",
    textAlign: "left",
    flexDirection: "column",
}));

export const Title = styled(HeadingXL)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(7),
}));

export const Paragraph = styled(BodyTextL)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    fontWeight: theme.typography.fontWeightBold,
}));

export const RadioGroupWrapper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    marginTop: theme.spacing(1),
}));

export const LoadingWrapper = styled(Stack)(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing(4),
}));
